<template>
    <div class="test-result-circle-wrapper">
        <div class="test-result-circle" :class="classType">
            <span v-if="show" class="test-result-count">{{ count }}</span>
        </div>
        <b-icon v-if="show" :icon="icon" class="circle-icon" size="is-small"/>
    </div>
</template>

<script>
    const classes = {
        "0": { type: "test-result-circle--passed" },
        "MTR_RES_PASSED": { type: "test-result-circle--passed" },
        "1": { type: "test-result-circle--skipped" },
        "MTR_RES_SKIPPED": { type: "test-result-circle--skipped" },
        "3": { type: "test-result-circle--passed-warnings" },
        "MTR_RES_PASSED_WARNINGS": { type: "test-result-circle--passed-warnings" },
        "4": { type: "test-result-circle--retry-passed" },
        "MTR_RES_RETRY_PASSED": { type: "test-result-circle--retry-passed" },
        "5": { type: "test-result-circle--retry-failed" },
        "MTR_RES_RETRY_FAILED": { type: "test-result-circle--retry-failed" },
        "MTR_RES_INFO": { type: "test-result-circle--info" },
        default: { type: "test-result-circle--failed" },
    };

    const icons = {
        "3": "alert",
        "MTR_RES_PASSED_WARNINGS": "alert",
        "4": "refresh",
        "MTR_RES_RETRY_PASSED": "refresh",
        "5": "refresh",
        "MTR_RES_RETRY_FAILED": "refresh",
        default: "",
    };

    export default {
        name: "TestResultCircle",
        props: {
            result: [Number, String],
            count: Number,
            hideIfZero: Boolean,
        },
        computed: {
            classType() {
                if (!this.show) return "";
                if (classes[this.result.toString()] == null) return classes.default.type;
                return classes[this.result.toString()].type;
            },
            show() {
                return this.count != null && !([0, "0"].includes(this.count) && this.hideIfZero);
            },
            icon() {
                if (icons[this.result.toString()] == null) return icons.default;
                return icons[this.result.toString()];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .test-result-circle-wrapper {
        position: relative;
    }

    .test-result-circle {
        width: 2rem;
        height: 2rem;
        position: relative;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
        font-size: 0.75rem;

        &--passed {
            background-color: $success;
            color: #fff;
        }
        &--skipped {
            background-color: $warning;
            color: #000;
        }
        &--info {
            background-color: $primary;
            color: #fff;
        }
        &--failed {
            background-color: $danger;
            color: #fff;
        }
        &--passed-warnings {
            background-color: $success;
            color: #fff;
        }
        &--retry-passed {
            background-color: $success;
            color: #fff;
        }
        &--retry-failed {
            background-color: $danger;
            color: #fff;
        }
    }

    .test-result-count {
        line-height: 2rem;
    }

    .circle-icon {
        position: absolute;
        right: -3px;
        bottom: -3px;
    }
</style>